import { useSnackbar } from 'notistack';
import type { SnackbarMessage, VariantType } from 'notistack';

export default function useAlert() {
  const { enqueueSnackbar } = useSnackbar();

  const onAlert = (message: SnackbarMessage, variant: VariantType) => {
    // variant could be success, error, warning, info, or default
    enqueueSnackbar(message, { variant });
  };

  return { onAlert };
}
